// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__zkDbt","title":"style_title__a0oKV"};